export const additionalChargesTab = {
  loading: "Chargement des paramètres…",
  tax: {
    title: "Taxe (TVA)",
    tag: "Incluse dans le prix",
    description:
      "La TVA est déjà <b>incluse</b> dans vos tarifs. Ici, vous définissez uniquement le pourcentage détaillé sur le reçu et la facture — <b>elle n'est pas ajoutée au total</b>.",
    hint: "Vide = la TVA de l'émetteur de facturation assigné est utilisée. S'applique uniquement aux réservations directes.",
  },
  cleaning: {
    title: "Frais de ménage",
    tag: "Fixe",
    description: "Montant fixe par séjour. Si <b>0</b>, il n'est pas appliqué.",
    showToGuest: "Afficher dans le récapitulatif de réservation",
  },
  charges: {
    title: "Frais supplémentaires",
    summary: "{count} frais configuré. | {count} frais configurés.",
    summaryEmpty: "Créez des frais optionnels (par réservation, par personne ou par nuit).",
    addButton: "Ajouter un frais",
    empty: "Aucun frais supplémentaire pour le moment.",
    headers: {
      title: "Intitulé",
      method: "Mode de facturation",
      value: "Valeur",
      visible: "Visible",
    },
    titlePlaceholder: "ex. Taxe de séjour",
    removeTitle: "Supprimer",
    hint: "Les frais visibles apparaissent sur une ligne distincte pour le client au moment du paiement ; les autres sont ajoutés au total.",
  },
  methods: {
    perStay: "Montant par réservation",
    perNight: "Montant par nuit",
    perPerson: "Montant par personne",
    perPersonPerNight: "Montant par personne et par nuit",
    percent: "% du total de la réservation",
  },
  validation: {
    cleaningInvalid: "Les frais de ménage doivent être un nombre valide et positif.",
    taxRange: "La TVA doit être comprise entre 0 et 100 %.",
    chargeTitleRequired: "Chaque frais supplémentaire doit avoir un intitulé.",
    chargeValueInvalid: 'La valeur du frais "{title}" est invalide.',
    chargePercentMax: 'Le pourcentage du frais "{title}" ne peut pas dépasser 100 %.',
  },
  toasts: {
    saveSuccess: "Frais supplémentaires enregistrés avec succès.",
    saveError: "Impossible d'enregistrer les frais supplémentaires.",
  },
};